import type {ReactElement} from 'react';
import React from 'react';
import type {SocialAccount} from '@Components/social-media/account.vo';
import {isFacebookAccount} from '@Components/social-media/account.vo';
import {getAssetUrl} from '@Utils/s3.util';
import {InputField} from '@Components/input-field-v2';
import {InputFieldSize} from '@Components/input-field-v2/input-field.types';
import {SocialPlatform} from '@Components/social-media/social-media.types';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import styles from './social-post-content-story-bottom-panel.module.scss';
import {Icon} from '@/components/icon-v2';

export interface SocialPostContentStoryBottomPanelProps {
  account: SocialAccount;
}

export function SocialPostContentStoryBottomPanel({account}: SocialPostContentStoryBottomPanelProps): ReactElement {
  const getBottomPanelForFacebook = (): ReactElement | null => {
    if (isFacebookAccount(account)) {
      return (
        <div className={styles.facebookWrapper}>
          <img className={styles.imgClasses} src={getAssetUrl('facebook-story-share.png')}></img>
          <InputField
            placeholder={`${window.window.i18next.t('pmwjs_send_message_ellipsis')}`}
            inputClassName={styles.inputStyles}
            className={styles.inputFieldStyles}
            size={InputFieldSize.XSMALL}
          />
          <div className={styles.reactsWrapper}>
            <img aria-hidden alt="facebook-story-love-react" className={styles.imgClasses} src={getAssetUrl('facebook-story-love-react.png')} />
            <img aria-hidden alt="facebook-story-like-react" className={styles.imgClasses} src={getAssetUrl('facebook-story-thumbs-up-react.png')} />
            <img aria-hidden alt="facebook-story-laughing-react" className={`${styles.imgClasses} ${styles.hahaReact}`} src={getAssetUrl('facebook-story-laughing-react.png')} />
          </div>
        </div>
      );
    }

    return null;
  };

  const getBottomPanelForInstagram = (): ReactElement | null => {
    if (account.type === SocialPlatform.INSTAGRAM) {
      return (
        <div className={styles.instagramWrapper}>
          <InputField
            placeholder={`${window.window.i18next.t('pmwjs_message')}`}
            inputClassName={styles.inputStylesInstagram}
            className={styles.inputFieldWrapperInstagram}
            size={InputFieldSize.XSMALL}
          />
          <div className={styles.instagramStoryReacts}>
            <Icon size={IconSize.SIZE_ICON_16} shape={IconShape.CIRCLE} type={IconType.DARK_GHOST} icon="icon-heart" />
            <Icon size={IconSize.SIZE_ICON_16} shape={IconShape.CIRCLE} type={IconType.DARK_GHOST} icon="icon-publish-arrow" />
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <div className={styles.bottomPanelWrapper}>
      {getBottomPanelForFacebook()} {getBottomPanelForInstagram()}
    </div>
  );
}
